export default __webpack_public_path__ + "static/media/HomeDisable.583329d3.svg";